<template>
  <div class="box-item top mb_20">
    <z-collapse :title="$t('loan.tradeInfo')">
      <ul class="c-list basic-list">
        <!--CIC融资申请单号：-->
        <li><span class="tit">{{ $t('loan.cicApplyNum') }}：</span><div class="msg">{{ subBaseData.financingCode }}</div></li>
        <!--关联订单：-->
        <li><span class="tit">{{ $t('loan.associatedOrder') }}：</span><div class="msg">{{ subBaseData.orderCode }}</div></li>
        <!--买家公司：-->
        <li><span class="tit">{{ $t('loan.buyerCompany') }}：</span><div class="msg company-name" @click="openkyc(subBaseData.buyerCode)">{{ subBaseData.buyerCompanyName }}</div></li>
        <!--卖家公司：-->
        <li><span class="tit">{{ $t('loan.salerCompany') }}：</span><div class="msg company-name" @click="openkyc(subBaseData.sellerCode)">{{ subBaseData.sellerCompanyName }}</div></li>
        <!--买家所属国：-->
        <li><span class="tit">{{ $t('loan.countryOfBuyer') }}：</span><div class="msg">{{ subBaseData.buyerCountryName }}</div></li>
        <!--卖家所属国：-->
        <li><span class="tit">{{ $t('loan.countryOfSaler') }}：</span><div class="msg">{{ subBaseData.sellerCountryName }}</div></li>
        <!--商品名称：-->
        <li><span class="tit">{{ $t('loan.goodsName') }}：</span><div class="msg">{{ subBaseData.productName }}</div></li>
        <!--商品类别：-->
        <li><span class="tit">{{ $t('loan.goodsCategory') }}：</span><div class="msg">{{ subBaseData.category }}</div></li>
        <!--产品描述：-->
        <li class="w-100"><span class="tit">{{ $t('loan.produceDescripe') }}：</span><div class="msg">{{ subBaseData.productDesc }}</div></li>

        <!--数量：-->
        <li><span class="tit">{{ $t('loan.number') }}：</span><div class="msg">
          {{ subBaseData.quantity }} {{ subBaseData.quantityUnit }}&nbsp;( +{{ subBaseData.overloading }}%/-{{ subBaseData.shorting }}% )
        </div></li>

        <!--单价：-->
        <li><span class="tit">{{ $t('loan.unitPrice') }}：</span>
          <div class="msg">{{ subBaseData.price | formatNum }} {{ subBaseData.priceCurrency }}/{{ subBaseData.priceUnit }}
            <span v-if="subBaseData.priceModality==2">
              {{ subBaseData.futuresContractName }}{{ subBaseData.raiseOrDiscount==1 ? '+' : '-' }}{{ subBaseData.raiseDiscountPrice | formatNum }} {{ subBaseData.priceCurrency }}/{{ subBaseData.priceUnit }}
            </span>
          </div>
        </li>
        <!--包装：-->
        <li><span class="tit">{{ $t('loan.packaging') }}：</span><div class="msg">{{ subBaseData.packing }}</div></li>
        <!--付款方式：-->
        <li><span class="tit">{{ $t('loan.paymentWay') }}：</span><div class="msg">{{ subBaseData.paymentMethod }}</div></li>
        <!--原有账期：-->
        <li><span class="tit">{{ $t('loan.originPaymentDays') }}：</span><div class="msg">{{ subBaseData.originalAccount }}</div></li>
        <!--贸易条款：-->
        <li><span class="tit">{{ $t('loan.tradeTerms') }}：</span><div class="msg">{{ subBaseData.tradeTerms }}</div></li>
        <!--预计装船日：-->
        <li><span class="tit">{{ $t('loan.expectShipmentDay') }}：</span><div class="msg">{{ subBaseData.estimateShipment }}</div></li>
        <!--装货港：-->
        <li><span class="tit">{{ $t('loan.loadingPort') }}：</span><div class="msg">{{ subBaseData.loadingPort }}</div></li>
        <!--原产国：-->
        <li><span class="tit">{{ $t('loan.originCountry') }}：</span><div class="msg">{{ subBaseData.originCountry }}</div></li>
        <!--卸货港：-->
        <li><span class="tit">{{ $t('loan.dischargePort') }}：</span><div class="msg">{{ subBaseData.unloadPort }}</div></li>
        <!--融资文件：-->
        <li class="w-100"><span class="tit">{{ $t('loan.financingFiles') }}：</span>
          <div v-if="subBaseData.intentLetterList && subBaseData.intentLetterList.length>0" class="msg c-file-list">
            <a v-for="(item, index) in subBaseData.intentLetterList" :key="index" :href="zmaDownloadFile(item.fileCode)"><i :class="getFileType(item.fileName)" class="file-icon"/>{{ item.fileName }}</a>
          </div>
        </li>
      </ul>
    </z-collapse>
    <!--    贸易信息-->

    <z-collapse :title="$t('loan.financingBasicInfo')">
      <ul class="c-list basic-list pb-20">
        <!--总金额：-->
        <li><span class="tit">{{ $t('loan.totalAmount') }}：</span><div class="msg">{{ subBaseData.totalSumUnit }} {{ subBaseData.totalSum | formatNum }}</div></li>
        <!--定金金额：-->
        <li><span class="tit">{{ $t('loan.depositAmount') }}：</span><div class="msg">{{ subBaseData.earnestMoneyUnit }} {{ subBaseData.earnestMoney | formatNum }}</div></li>
        <!--申请金额：-->
        <li><span class="tit">{{ $t('loan.applyAmount') }}：</span><div class="msg">{{ subBaseData.applyAmountUnit }} {{ subBaseData.applyAmount | formatNum }}</div></li>
        <!--申请账期：-->
        <li><span class="tit">{{ $t('loan.applyPaymentDays') }}：</span><div class="msg">{{ subBaseData.applyDate }}</div></li>
        <!--融资用途：-->
        <li><span class="tit">{{ $t('loan.financingUse') }}：</span><div class="msg">{{ subBaseData.financingPurposes }}</div></li>
        <!--还款来源：-->
        <li><span class="tit">{{ $t('loan.repaymentSource') }}：</span><div class="msg">{{ subBaseData.repaymentSource }}</div></li>
        <!--担保类型：-->
        <li><span class="tit">{{ $t('loan.collateralType') }}：</span><div class="msg">{{ subBaseData.typeOfGuarantee }}</div></li>
        <!--代理平台：-->
        <li><span class="tit">{{ $t('loan.agencyPlat') }}：</span><div class="msg">{{ subBaseData.agentPlatformName }}</div></li>
        <!--融资申请方：-->
        <li><span class="tit">{{ $t('loan.financingApplicant') }}：</span><div class="msg">{{ subBaseData.applyUserType == 1? subBaseData.buyerCompanyName : subBaseData.sellerCompanyName }}</div></li>
      </ul>
    </z-collapse>
    <!--    融资基础信息-->

    <el-dialog
      :visible.sync="kycDialog"
      :title="$t('newrisk.user_profile')"
      width="720px"
    >
      <div style="padding:30px 40px;" class="profile-div">
        <el-row style="margin-bottom:20px;">
          <el-col :span="8">{{ $t('newrisk.kyc_1') }}：</el-col>
          <el-col v-if="kycInfo.businessFileList" :span="16" style="">
            <a v-for="(v,i) in kycInfo.businessFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:20px;">
          <el-col :span="8">{{ $t('newrisk.kyc_2') }}：</el-col>
          <el-col v-if="kycInfo.corportateFileList" :span="16" style="color:#7996F5;">
            <a v-for="(v,i) in kycInfo.corportateFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:20px;">
          <el-col :span="8">{{ $t('newrisk.kyc_3') }}：</el-col>
          <el-col v-if="kycInfo.financialFileList" :span="16" style="color:#7996F5;">
            <a v-for="(v,i) in kycInfo.financialFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="8">{{ $t('newrisk.kyc_4') }}：</el-col>
          <el-col v-if="kycInfo.otherFileList" :span="16" style="color:#7996F5;">
            <a v-for="(v,i) in kycInfo.otherFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import ZCollapse from '../ZCollapse'
import mixins from '@/helper/mixins.js'
export default {
  name: 'BaseInfoOne',
  components: {
    ZCollapse
  },
  mixins: [mixins],
  props: {
    subBaseData: { // baseDataOne
      type: Object
    }
  },
  data() {
    return {
      dataObj: this.subBaseData,
      kycInfo: '',
      kycDialog: false
    }
  },

  mounted() {
    console.log(this.dataObj)
  },
  methods: {
    openkyc(code) {
      this.axios.post('/api/zma/risk/getkycfilebyUsercode', { code: code }).then(res => {
        if (res.status) {
          this.kycInfo = res.data
          this.kycDialog = true
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-list{
  display: flex;
  flex-wrap: wrap;
  li{
    width: 510px;
    &.w-100{
      width:100%
    }
    .company-name{
  // font-size: 18px;
  color: #7996F5;
  // line-height: 25px;
  cursor: pointer;
}
  }
}
::v-deep.el-dialog {
    .el-dialog__close {
      width: 14px;
      height: 14px;
      color: #fff;
    }

    .el-dialog__header {
      background: #40404d;
      height: 70px;
      padding: 0;
      text-align: center;
      line-height: 70px;
      font-size: 18px;
      .el-dialog__title {
        color: #ffffff !important;
        font-family: PingFangSC-Regular;
      }
    }
    .el-dialog__body {
      padding: 0;

      .el-input__inner {
        height: 36px;
      }
    }
  }
  .profile-div{
  .file-icon{
    display: inline-block;
    width: 20px;
    height: 19px;
    vertical-align: middle;
    margin-right: 11px;
  }
}
</style>
